/**
 * Ассеты пака «По-турецки» — имена файлов как в `packs/turkish/` (в т.ч. опечатка bg-moble).
 */
import turkishBgDesktop from '@/assets/img/rice-game/packs/turkish/bg-desktop.jpg';
import turkishBgDesktop2x from '@/assets/img/rice-game/packs/turkish/bg-desktop@2x.jpg';
import turkishBgMobile from '@/assets/img/rice-game/packs/turkish/bg-moble.jpg';
import turkishBgMobile2x from '@/assets/img/rice-game/packs/turkish/bg-moble@2x.jpg';

import turkishStateD01 from '@/assets/img/rice-game/packs/turkish/state_desktop_1.png';
import turkishStateD02 from '@/assets/img/rice-game/packs/turkish/state_desktop_2.png';
import turkishStateD03 from '@/assets/img/rice-game/packs/turkish/state_desktop_3.png';
import turkishStateD04 from '@/assets/img/rice-game/packs/turkish/state_desktop_4.png';
import turkishStateD05 from '@/assets/img/rice-game/packs/turkish/state_desktop_5.png';
import turkishStateD06 from '@/assets/img/rice-game/packs/turkish/state_desktop_6.png';
import turkishStateD07 from '@/assets/img/rice-game/packs/turkish/state_desktop_7.png';
import turkishStateD08 from '@/assets/img/rice-game/packs/turkish/state_desktop_8.png';
import turkishStateD09 from '@/assets/img/rice-game/packs/turkish/state_desktop_9.png';
import turkishStateD10 from '@/assets/img/rice-game/packs/turkish/state_desktop_10.png';
import turkishStateD11 from '@/assets/img/rice-game/packs/turkish/state_desktop_11.png';
import turkishStateD12 from '@/assets/img/rice-game/packs/turkish/state_desktop_12.png';
import turkishStateD13 from '@/assets/img/rice-game/packs/turkish/state_desktop_13.png';

import turkishStateM01 from '@/assets/img/rice-game/packs/turkish/state_mobile_1.png';
import turkishStateM02 from '@/assets/img/rice-game/packs/turkish/state_mobile_2.png';
import turkishStateM03 from '@/assets/img/rice-game/packs/turkish/state_mobile_3.png';
import turkishStateM04 from '@/assets/img/rice-game/packs/turkish/state_mobile_4.png';
import turkishStateM05 from '@/assets/img/rice-game/packs/turkish/state_mobile_5.png';
import turkishStateM06 from '@/assets/img/rice-game/packs/turkish/state_mobile_6.png';
import turkishStateM07 from '@/assets/img/rice-game/packs/turkish/state_mobile_7.png';
import turkishStateM08 from '@/assets/img/rice-game/packs/turkish/state_mobile_8.png';
import turkishStateM09 from '@/assets/img/rice-game/packs/turkish/state_mobile_9.png';
import turkishStateM10 from '@/assets/img/rice-game/packs/turkish/state_mobile_10.png';
import turkishStateM11 from '@/assets/img/rice-game/packs/turkish/state_mobile_11.png';
import turkishStateM12 from '@/assets/img/rice-game/packs/turkish/state_mobile_12.png';
import turkishStateM13 from '@/assets/img/rice-game/packs/turkish/state_mobile_13.png';

export const turkishFramesDesktop = [
  turkishStateD01,
  turkishStateD02,
  turkishStateD03,
  turkishStateD04,
  turkishStateD05,
  turkishStateD06,
  turkishStateD07,
  turkishStateD08,
  turkishStateD09,
  turkishStateD10,
  turkishStateD11,
  turkishStateD12,
  turkishStateD13,
];

export const turkishFramesMobile = [
  turkishStateM01,
  turkishStateM02,
  turkishStateM03,
  turkishStateM04,
  turkishStateM05,
  turkishStateM06,
  turkishStateM07,
  turkishStateM08,
  turkishStateM09,
  turkishStateM10,
  turkishStateM11,
  turkishStateM12,
  turkishStateM13,
];

export const turkishBackgrounds = {
  backgroundDesktop: turkishBgDesktop,
  backgroundDesktop2x: turkishBgDesktop2x,
  backgroundMobile: turkishBgMobile,
  backgroundMobile2x: turkishBgMobile2x,
};
